import RecommendedBrowserBanner from './RecommendedBrowserBanner.vue';

export default RecommendedBrowserBanner;
